<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">我的危化品使用日志</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="formInline.user_name" clearable placeholder="请输入姓名"></el-input>
        </el-form-item> -->
        <el-form-item label="危化品">
          <el-input v-model="formInline.name" clearable placeholder="请输入危化品"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed prop="name" label="危化品名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="number" label="编码" width="120">
        </custom-table-column>
        <custom-table-column prop="usage" label="使用用途" min-width="220">
        </custom-table-column>
        <custom-table-column prop="use_at" label="使用时间" width="160">
        </custom-table-column>
        <custom-table-column prop="training_room" :label="`所属${$store.state.themeTitle}室`" min-width="180">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" min-width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" min-width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="grade" label="年级" width="100">
        </custom-table-column>
        <custom-table-column prop="type2" label="类别" width="150">
        </custom-table-column>
        <custom-table-column prop="type" label="类型" width="150">
        </custom-table-column>
        <custom-table-column prop="price" label="价格（元）" width="150">
        </custom-table-column>
        <custom-table-column prop="school_area" label="校区" width="180">
        </custom-table-column>
        <custom-table-column prop="building_name" label="楼宇名称" width="180">
        </custom-table-column>
        <custom-table-column prop="supplier" label="销售商" width="150">
        </custom-table-column>
        <custom-table-column prop="address" label="地点" width="150">
        </custom-table-column>
        <custom-table-column prop="manufacturer" label="制造商" width="150">
        </custom-table-column>
        <custom-table-column prop="goods_usage" label="使用方向" width="150">
        </custom-table-column>
        <custom-table-column prop="place" label="存放地点" width="150">
        </custom-table-column>
        <custom-table-column prop="size" label="规格" width="150">
        </custom-table-column>
        <custom-table-column prop="cc_number" label="出厂编号" width="150">
        </custom-table-column>
        <custom-table-column prop="desc" label="备注" width="220">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="归还" :visible.sync="centerDialogVisible" width="406px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="归还日期" prop="return_date">
          <el-date-picker type="datetime" placeholder="选择归还日期" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.return_date" style="width:242px;"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm',changeReturnStatus)">确认</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      formInline: {
        // user_name: '',
        name: '',
        // structure_1: '',
        // major: '',
        // status:''
      },
      levell: [1, 2],
      organLabel: '',
      detailDialogVisible: false,
      eqs: [],
      rowObj: [],
      Returns: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        training_room_id: '',
        order_start: '',
        order_end: '',
        reason: '',
        items: [],
      },
      numberDialogVisible:false,
      listArr: [],
      remainder_quantity: 0,
      rules: {
        training_room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        order_start: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        order_end: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        reason: [{ required: true, message: '申请理由不能为空', trigger: 'blur' }],
      },
      ruleForm1: {
        id:'',
        return_date: '',
      },
      rules1: {
        return_date: [{ required: true, message: '请选择废弃时间', trigger: 'change' }],
      },
      rules1: {},
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  methods: {
    handleReturn(id) {
      this.numberDialogVisible = true;
      this.ruleForm1.id = id;
    },
    async changeReturnStatus() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      let res = await this.$api.instance.interfaceServer(`api/danger_goods/borrow/return`, 'post',params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '状态修改成功！',
        });
        this.ruleForm1 = {
          id: '',
          type: '',
          number: 0,
        };
        this.numberDialogVisible = false;
        this.handleQuery();
      }
    },
    handleOper(id, status) {
      let str = '通过';
      if (status == 'refuse') {
        str = '否决';
      }
      this.confirmBox('warning', `此操作将${str}该借用申请，是否继续`, { id, status }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/danger_goods/borrow/apply/oper/${params.id}`, 'post', { status: params.status });
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.getList();
      }
    },
    async handleClassChange(e) {
      if (this.ruleForm.training_room_id) {
        let params = { training_room_id: this.ruleForm.training_room_id };
        params.page = 1;
        params.size = 9999;
        let res = await this.$api.instance.interfaceServer('api/training/common/room/device/list', 'get', params);
        if (res.code == 0 && res.data) {
          this.eqs = res.data.data;
        }
      } else {
        this.eq = [];
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteDeviceInto() {
      // let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/danger_goods/records/delete/${this.delid}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.items = params.items.map((item) => {
        return {
          type: item.type,
          name: item.name,
          num: item.num,
          id: item.id,
        };
      });
      params.items = JSON.stringify(params.items);
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // async updateJournalOfTearcher() {
    //   let params = this.$until.easyDeepCopy(this.ruleForm);;
    //   let res = await this.$api.update.updateJournalOfTearcher(params);
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '编辑成功！',
    //     });
    //     this.clearState();
    //   }
    // },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/danger_goods/records/listMy', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
